<template>
    <div class="news-list">
        <div v-for="news in data" class="news-item" @click="itemClick(news)">
            <div class="col-xs-12 col-sm-3 col-md-3">
                <div class="">
                    <a href="javascript:void(0)" rel="bookmark">
                        <img :src="news.news_img" class="media-object news-img" alt="">
                    </a>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-9 news-info">
                <h3>
                    <div class="news-time">
                        <span>{{news.formateDate}}</span>
                        <span>{{news.formateYear}}</span>
                    </div>
                    <a href="javascript:void(0)">{{news.news_title}}</a>
                </h3>
                <div class="news-desc">
                    <p>{{news.news_intro}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "list",
        props: ['data'],
        methods:{
            itemClick(item){
                this.$emit("itemClick",item);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/news/List.vue